import axios from 'axios';

export const stock = {
  getStockQuotationData() {
    return axios({
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://origin-console-service.onrender.com/api/stock_quotation?market=SET,mai&indexSector=SET50,FINCIAL,BANK&securityType=CS,DWC,DWP&stockSymbol=ORI&oddLotFlag=true',
      headers: {
        'api-key': 'YOUR_API_KEY'
      }
    })
      .then(function (response) {
        return response.data
      }).catch(() => {
        return false
      });
  },


  getStockNewsData(lang = 'th') {
    const selectedLang = lang === 'en' ? 'en' : 'th';

    return axios({
      method: 'GET',
      maxBodyLength: Infinity,
      url: `${process.env.VUE_APP_API}/new_set?lang=${selectedLang}`,
    })
      .then(response => response.data)
      .catch(() => false);
  },
};